/**
 * 비교 축 선택기 — "무엇끼리 비교할 것인가".
 *
 * 위젯마다 다른 축을 볼 수 있어야 한다. 사업자별로는 판정 보류가 나오지만
 * 제조사·타입별로는 결론이 나오는 식으로, **축을 바꾸면 답이 달라진다**는 것
 * 자체가 이 도구가 보여줘야 할 내용이다.
 */

import { RANK_ENTITIES, type RankEntity } from '@/lib/types'
import './EntityPicker.css'

interface Props {
  value: RankEntity
  onChange: (next: RankEntity) => void
  label?: string
}

export function EntityPicker({ value, onChange, label = '비교 축' }: Props) {
  return (
    <div className="epick" role="group" aria-label={label}>
      {RANK_ENTITIES.map((e) => (
        <button
          key={e.key}
          type="button"
          className={`epick__btn${value === e.key ? ' is-on' : ''}`}
          aria-pressed={value === e.key}
          onClick={() => onChange(e.key)}
        >
          {e.label}
        </button>
      ))}
    </div>
  )
}
